import { Blockchain } from "@rarible/api-client"
import { megaethTestnet } from "viem/chains"
import { toCurrencyId } from "../../../price/types"
import { FEE_CONFIG_URL } from "../constants"
import type { StaticEthereumBlockchainConfig } from "../types"

export const megaEthTestnetConfig: StaticEthereumBlockchainConfig = {
  name: "MegaETH",
  icon: "/images/blockchains/mega-eth.svg",
  isEvm: true,
  testnet: true,
  isTestnet: true,
  feesVersion: "v3",
  treasury: "0x64d34BcfC32Fb663172C47d6E4Fb1dBFaba6e7a2",
  unionApi: "https://api.rarible.org",
  basePath: "https://megaethtestnet-api.rarible.org",
  chainId: 6342,
  blockchain: Blockchain.MEGAETHTESTNET,
  chainName: "MegaETH Testnet",
  exchange: {
    v2: "0x2482362A172f0D00fC05A2b238c6F2dDF8352F42",
    wrapper: "0x8087e2635de72235f63d9Ac63c462671caCcE2c6",
  },
  blockExplorers: [
    {
      url: "https://www.megaexplorer.xyz/",
      icon: "/images/scanner.svg",
      adress: "https://www.megaexplorer.xyz/address/${adrress}",
    },
  ],
  rpcUrls: [{ url: "https://carrot.megaeth.com/rpc", isPublic: true }],
  privateRpcNodeSlug: "testnet-megaeth-node",
  transferProxies: {
    nft: "0xa058a1a9fB073D88d9FA3caD40d2b8d01E1195c5",
    erc721Lazy: "0xa199882F70c7d3F7DCAe4abEe607C85756096fF2",
    erc20: "0x41ACa3f152Ce4c90A36c6Cb7818EBe0cF5ad725D",
  },
  feeConfigUrl: FEE_CONFIG_URL,
  primaryCurrency: {
    id: toCurrencyId(
      "MEGAETHTESTNET:0x0000000000000000000000000000000000000000",
    ),
    symbol: "ETH",
    name: "ETH",
    decimals: 18,
  },
  wrappedCurrency: {
    id: toCurrencyId(
      "MEGAETHTESTNET:0x4eb2bd7bee16f38b1f4a0a5796fffd028b6040e9",
    ),
    symbol: "WETH",
    name: "WETH",
    decimals: 18,
  },
  addFundsLink: "https://testnet.megaeth.com/?faucet=true",
  hasStabilityProtocol: true,
  viem: megaethTestnet,
}

export const getMegaEthTestnetConfig = (): StaticEthereumBlockchainConfig =>
  megaEthTestnetConfig
